import type { LabelPreviewData } from '@/types/label-template';
import { DESIGNER_PREVIEW_DEFAULT_LABEL } from '@/utils/designer-preview-defaults';

export const STORAGE_KEY = 'label-designer.preview-test';

export type PreviewTestOverrides = Partial<LabelPreviewData['label']>;

export interface PreviewTestStorage {
  enabled: boolean;
  overrides: PreviewTestOverrides;
}

function readRaw(): PreviewTestStorage {
  if (typeof window === 'undefined') {
    return { enabled: false, overrides: {} };
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { enabled: false, overrides: {} };
    const parsed = JSON.parse(raw) as PreviewTestStorage;
    return {
      enabled: Boolean(parsed?.enabled),
      overrides: parsed?.overrides && typeof parsed.overrides === 'object' ? parsed.overrides : {},
    };
  } catch {
    return { enabled: false, overrides: {} };
  }
}

export function loadPreviewTestStorage(): PreviewTestStorage {
  return readRaw();
}

export function savePreviewTestStorage(payload: PreviewTestStorage) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function defaultPreviewTestOverrides(): PreviewTestOverrides {
  return { ...DESIGNER_PREVIEW_DEFAULT_LABEL };
}
